import imageCompression from 'browser-image-compression';

var resultGLBFile = null;
var checkCompleteExportTimer;

var files=[];
var fileblobs=[];
var gltf;
var allfilestoprocess;
var remainingfilestoprocess=0;
var glbfilename;

var outputBuffers;
var bufferMap;
var bufferOffset;

function handleDragOver (event) {
  event.stopPropagation();
  event.preventDefault();
  event.dataTransfer.dropEffect = 'copy';
}

// var dropZone = document.getElementById('drop_zone');
// dropZone.addEventListener('dragover', handleDragOver, false);
// dropZone.addEventListener('drop', handleFileSelect, false);

// function addDownloadButton () {
//   var btn = document.createElement("button");
//   btn.id="downloadBtn";
//   btn.disabled=true;
//   btn.onclick= startDownload;
//   btn.appendChild(document.createTextNode("Processing..."));
//   document.getElementById("download").appendChild(btn);
// }

function startDownload () {
  document.getElementById("downloadLink").click();
}

async function handleFileSelect (event) {
  return new Promise(resolve => {
    // console.log('handleFileSelect')
    event.stopPropagation()
    event.preventDefault()
    // document.getElementById('list').innerHTML="";
    // addDownloadButton();
    var items = event.dataTransfer.items
    remainingfilestoprocess = items.length
    allfilestoprocess = items.length

    for (var i=0; i<items.length; i++) {
      if (items[i].getAsEntry) {
        var entry = items[i].getAsEntry()
      } else if (items[i].webkitGetAsEntry) {
        var entry = items[i].webkitGetAsEntry()
      }
      if (entry) {
        traverseFileTree(entry);
      }
    }

    var checkCompleteExport = () => {
      if (resultGLBFile) {
        clearInterval(checkCompleteExportTimer)
        return resolve(resultGLBFile)
      }
    }
    checkCompleteExportTimer = setInterval(checkCompleteExport, 400)
  })
}

async function getFile (fileEntry) {
  try {
    return await new Promise((resolve, reject) => fileEntry.file(resolve, reject))
  } catch (err) {
    // console.log(err)
  }
}

// 再帰関数
async function traverseFileTree (item, path) {
  path = path || "";
  if (item.isFile) {
    var file = await getFile(item)
    files.push(file);
    
    var extension = file.name.split('.').pop();
    if (extension === "gltf") {
      glbfilename=file.name.substr(file.name.lastIndexOf('/')+1,file.name.lastIndexOf('.'));
      var reader = new FileReader();
      reader.readAsText(file);

      await new Promise(resolve => reader.onload = () => resolve());
      gltf = JSON.parse(reader.result);
      const resultFile = await checkRemaining();
      // console.log('traverse resultFile1:', resultFile)
    } else {
      var reader = new FileReader();
      
      // file.typeが'image/jpeg'or 'image/png'の場合は 圧縮 (& モノクロ化）
      var targetFile
      var imageTypes = ['image/png', 'image/jpg', 'image/jpeg']
      if (imageTypes.includes(file.type)) {
        var options = {
          // maxSizeMB: 0.5,
          maxSizeMB: 0.3,
          // maxWidthOrHeight: 512,
          maxWidthOrHeight: 256,
          // maxWidthOrHeight: 128,
          useWebWorker: true
        }
        var targetFile = await imageCompression(file, options);
        // console.log(`compression: ${file.size} to ${targetFile.size}`)
        reader.readAsArrayBuffer(targetFile);
      } else {
        targetFile = file
        reader.readAsArrayBuffer(targetFile);
      }
      await new Promise(resolve => reader.onload = () => resolve());
      fileblobs[targetFile.name.toLowerCase()]=(reader.result);
      var resultFile = await checkRemaining();
      // console.log('traverse resultFile2:', resultFile)
    }
  } else if (item.isDirectory) {
    var dirReader = item.createReader();
    dirReader.readEntries(async function(entries) {
      remainingfilestoprocess+=entries.length;
      var resultFile = await checkRemaining();
      // console.log('traverse resultFile in directory3:', resultFile)
      for (var i=0; i<entries.length; i++) {
        traverseFileTree(entries[i], path + item.name + "/");
      }
    });

    // var entries = []
    // var dirReader = item.createReader();
    // var readDir = async _entries => {
    //   await new Promise(resolve => {
    //     dirReader.readEntries(async entry => {
    //       if (entry.length !== 0) {
    //         _entries.push(...entry)
    //         await readDir(_entries)
    //       }
    //       return resolve(_entries)
    //     })
    //   })
    //   return Promise.resolve(_entries)
    // }
    // entries.push(...(await readDir([])))
  }
}

async function checkRemaining () {
  remainingfilestoprocess--;
  if(remainingfilestoprocess===0){
    outputBuffers = [];
    bufferMap = new Map();
    bufferOffset = 0;
    // processBuffers().then(fileSave);

    await processBuffers()
    const file = await fileSave()
    // console.log('file:', file)
    return file
  } else {
    return false
  }
}

function processBuffers () {
  var pendingBuffers = gltf.buffers.map(function (buffer, bufferIndex) {
    return dataFromUri(buffer)
      .then(function(data) {
        if (data !== undefined) {
          outputBuffers.push(data);
        }
        delete buffer.uri;
        buffer.byteLength = data.byteLength;
        bufferMap.set(bufferIndex, bufferOffset);
        bufferOffset += alignedLength(data.byteLength);
      });
  });

  return Promise.all(pendingBuffers)
    .then(function() {
      var bufferIndex = gltf.buffers.length;
      var images = gltf.images || [];
      var pendingImages = images.map(function (image) {
        return dataFromUri(image).then(function(data) {
          if (data === undefined) {
              delete image['uri'];
              return;
          }
          var bufferView = {
              buffer: 0,
              byteOffset: bufferOffset,
              byteLength: data.byteLength,
          };
          bufferMap.set(bufferIndex, bufferOffset);
          bufferIndex++;
          bufferOffset += alignedLength(data.byteLength);
          var bufferViewIndex = gltf.bufferViews.length;
          gltf.bufferViews.push(bufferView);
          outputBuffers.push(data);
          image['bufferView'] = bufferViewIndex;
          image['mimeType'] = getMimeType(image.uri);
          delete image['uri'];
        });
      });
      return Promise.all(pendingImages);
  });
}

function fileSave () {
  var Binary = {
    Magic: 0x46546C67
  };

  for (var _i = 0, _a = gltf.bufferViews; _i < _a.length; _i++) {
    var bufferView = _a[_i];
    if (bufferView.byteOffset=== undefined){
      bufferView.byteOffset=0;
    } else {
      bufferView.byteOffset = bufferView.byteOffset + bufferMap.get(bufferView.buffer);
    }
    bufferView.buffer = 0;
  }
  var binBufferSize = bufferOffset;
  gltf.buffers = [{
      byteLength: binBufferSize
  }];

  var enc = new TextEncoder();
  var jsonBuffer = enc.encode(JSON.stringify(gltf));
  var jsonAlignedLength = alignedLength(jsonBuffer.length);
  var padding;
  if (jsonAlignedLength !== jsonBuffer.length) {

      padding = jsonAlignedLength- jsonBuffer.length;
  }
  var totalSize = 12 + // file header: magic + version + length
      8 + // json chunk header: json length + type
      jsonAlignedLength +
      8 + // bin chunk header: chunk length + type
      binBufferSize;
  var finalBuffer = new ArrayBuffer(totalSize);
  var dataView = new DataView(finalBuffer);
  var bufIndex = 0;
  dataView.setUint32(bufIndex, Binary.Magic, true);
  bufIndex += 4;
  dataView.setUint32(bufIndex, 2, true);
  bufIndex += 4;
  dataView.setUint32(bufIndex, totalSize, true);
  bufIndex += 4;
  // JSON
  dataView.setUint32(bufIndex, jsonAlignedLength, true);
  bufIndex += 4;
  dataView.setUint32(bufIndex, 0x4E4F534A, true);
  bufIndex += 4;

  for (var j=0;j<jsonBuffer.length;j++){
      dataView.setUint8(bufIndex, jsonBuffer[j]);
      bufIndex++;
  }
  if(padding!==undefined){
      for (var j=0;j<padding;j++){
          dataView.setUint8(bufIndex, 0x20);
      bufIndex++;
  }
  }

  // BIN
  dataView.setUint32(bufIndex, binBufferSize, true);
  bufIndex += 4;
  dataView.setUint32(bufIndex, 0x004E4942, true);
  bufIndex += 4;
  for (var i = 0; i < outputBuffers.length; i++) {
    var bufoffset = bufIndex + bufferMap.get(i);
    var buf = new Uint8Array(outputBuffers[i]);
    var thisbufindex=bufoffset;
    for (var j=0;j<buf.byteLength;j++){
      dataView.setUint8(thisbufindex, buf[j]);
      thisbufindex++;
  }
  }
  
  resultGLBFile = new Blob([finalBuffer], {type: 'model/json-binary'})
  // console.log('GLB:', resultGLBFile)
  
  // var a = document.getElementById("downloadLink");
  // a.href = URL.createObjectURL(resultGLBFile);
  // a.download = glbfilename+".glb";
  // // document.getElementById("downloadBtn").disabled=false;
  // document.getElementById("downloadBtn").textContent="Download .glb";
  // a.click();

  return resultGLBFile
}


function isBase64 (uri) {
  return uri.length < 5 ? false : uri.substr(0, 5) === "data:";
}
function decodeBase64 (uri) {
  return fetch(uri).then(function(response) { return response.arrayBuffer(); });
}
function dataFromUri (buffer) {
  if (buffer.uri === undefined) {
    return Promise.resolve(undefined);
  } else if (isBase64(buffer.uri)) {
    return decodeBase64(buffer.uri);
  } else {
    var filename=buffer.uri.substr(buffer.uri.lastIndexOf('/')+1);
    return Promise.resolve(fileblobs[filename.toLowerCase()]);
  }
}
function alignedLength (value) {
  var alignValue = 4;
  if (value == 0) {
      return value;
  }
  var multiple = value % alignValue;
  if (multiple === 0) {
      return value;
  }
  return value + (alignValue - multiple);
}

function getMimeType (filename) {
  for (var mimeType in gltfMimeTypes) {
      for (var extensionIndex in gltfMimeTypes[mimeType]) {
          var extension = gltfMimeTypes[mimeType][extensionIndex];
          if (filename.toLowerCase().endsWith('.' + extension)) {
              return mimeType;
          }
      }
  }
  return 'application/octet-stream';
}

var gltfMimeTypes = {
  'image/png': ['png'],
  'image/jpeg': ['jpg', 'jpeg'],
  'text/plain': ['glsl', 'vert', 'vs', 'frag', 'fs', 'txt'],
  'image/vnd-ms.dds': ['dds']
};

export { handleDragOver, handleFileSelect }